import { pdf } from '@react-pdf/renderer';
import type { POModal, PoModalModifiers, PurchaseOrderDetails, Vendor } from 'api/types';
import UploadImage from 'components/UploadImage';
import { getS3Path } from 'utils/index';
import PurchaseOrderPdfView from './PurchaseOrderPdfView';

interface BlobGeneratorProps {
  data: POModal[];
  vendorBillingData: Vendor;
  deliveryAddress: string;
  poModifiers: PoModalModifiers;
  specialInstructions: string;
  poResponse: PurchaseOrderDetails;
  requester: string;
  poDate: string;
  purchaseDate: string;
  fileName?: string;
  paymentTerms: string;
}

const UploadPurchaseOrderBlob = async (props: BlobGeneratorProps) => {
  try {
    const blob = await pdf(
      <PurchaseOrderPdfView
        data={props.data}
        vendorBillingData={props.vendorBillingData}
        poModifiers={props.poModifiers}
        specialInstructions={props.specialInstructions}
        poResponse={props.poResponse}
        requester={props.requester}
        poDate={props.poDate}
        purchaseDate={props.purchaseDate}
        deliveryAddress={props.deliveryAddress}
        paymentTerms={props.paymentTerms}
      />
    ).toBlob();

    const fileName_ = props.fileName || props.poResponse.purchase_order_number || '0000.pdf';
    const uniqueFileName = `${Date.now()}_${fileName_}.pdf`.replaceAll(' ', '-');
    const pdfFile = new File([blob], uniqueFileName, { type: 'application/pdf' });
    const s3Path = getS3Path(fileName_, 'system-generated-purchase-orders');
    await UploadImage(pdfFile, s3Path);
    return { blob, fileName_ };
  } catch (error) {
    console.error('Error generating PDF blob:', error);
    throw error;
  }
};

export default UploadPurchaseOrderBlob;
